import { INTELLIGENCE_DAILY_NAV_SLUG, INTELLIGENCE_FIRM_SUMMARY_SLUG } from 'common/constants/firms';

export const INTELLIGENCE_SECONDARY_NAVIGATION_LABELS = {
  SUMMARIES: 'Summaries',
  SCHEDULE_OF_INVESTMENTS: 'Schedule of Investments',
  DAILY_NAV: 'Daily NAV',
} as const;

export const INTELLIGENCE_SECONDARY_NAVIGATION_SLUGS = {
  SUMMARIES: 'summaries',
  SCHEDULE_OF_INVESTMENTS: 'schedule-of-investments',
  DAILY_NAV: INTELLIGENCE_DAILY_NAV_SLUG,
} as const;

export const INTELLIGENCE_DEFAULT_SECONDARY_NAVIGATION_SLUG = INTELLIGENCE_SECONDARY_NAVIGATION_SLUGS.SUMMARIES;

export const INTELLIGENCE_TERTIARY_NAVIGATION_LABELS = {
  FIRM_SUMMARY: 'Firm Summary',
} as const;

export const INTELLIGENCE_TERTIARY_NAVIGATION_SLUGS = {
  FIRM_SUMMARY: INTELLIGENCE_FIRM_SUMMARY_SLUG,
} as const;

export const INTELLIGENCE_DEFAULT_TERTIARY_NAVIGATION_SLUG = INTELLIGENCE_TERTIARY_NAVIGATION_SLUGS.FIRM_SUMMARY;

export const INTELLIGENCE_CUSTOM_VIEW_SLUG_PREFIX = 'view-';
